import React, {useContext, useEffect, useState} from 'react';
import common from '../../common.module.scss';
import {getPrivateGameById, getPrivateGames, putStatus} from './api/PrivateGamesApi';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';
import Pagination from '../pagination';
import {Popup} from "../../../../shared/ui/Popup";
import styles from './privateGames.module.css';
import mob from  '../mobileBlockSchedule/MobileBlock.module.scss'
import {useNavigate} from "react-router-dom";
import {EmployeeContext} from "../../context/EmployeeContext.jsx";
import useIsMobile from "@/shared/lib/hooks/useIsMobile";

// добавлено:
import { GiSettingsKnobs } from "react-icons/gi";
import FilterModal from "@/shared/ui/FiltersModal";

export default function PrivateGames() {
    const navigate = useNavigate();
    const { employee } = useContext(EmployeeContext);
    const role = employee?.role;

    const isMobile = useIsMobile();

    const [games, setGames] = useState([]);
    const [search, setSearch] = useState('');
    const [sortBy, setSortBy] = useState('');
    const [direction, setDirection] = useState('asc');
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    const [open, setOpen] = useState(false);
    const [gameById, setGameById] = useState(null);

    // добавлено:
    const [showModalFilters, setShowModalFilters] = useState(false);

    useEffect(() => {
        fetchGames();
    }, [page, search, sortBy, direction]);

    const fetchGames = async () => {
        try {
            const res = await getPrivateGames({
                page,
                size: 10,
                ...(search && { search }),
                ...(sortBy && { sortBy }),
                ...(sortBy && { direction }),
            });
            setGames(res.data.content || []);
            setTotalPages(res.data.totalPages || 1);
        } catch (err) {
            toast.error(err?.response?.data?.message || "Ошибка при получении заявок");
            console.error(err);
        }
    };

    const handleSort = (field) => {
        if (sortBy !== field) {
            setSortBy(field);
            setDirection('desc');
        } else if (direction === 'desc') {
            setDirection('asc');
        } else {
            setSortBy('');
            setDirection('asc');
        }
        setPage(0);
    };

    const renderSortArrow = (field) => {
        if (sortBy !== field) return '';
        return direction === 'asc' ? ' ↑' : ' ↓';
    };

    const extractTelegramUsername = (input) => {
        if (!input) return '';
        try {
            return input.trim()
                .replace(/^https?:\/\/(www\.)?t\.me\//i, '')
                .replace(/^@/, '')
                .split(/[/?#]/)[0];
        } catch (e) {
            console.error(e)
            return '';
        }
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 0 && newPage < totalPages) {
            setPage(newPage);
        }
    };

    const handleMore = async (id) => {
        try {
            const res = await getPrivateGameById(id);
            setGameById(res.data);
        } catch (err) {
            toast.error(err?.response?.data?.message|| "Ошибка получения данных закрытой игры");
        }
    };

    const closePopup = () => setOpen(false);

    const navigateToSchedule = (id) => {
        return navigate(
            `/admin/schedule/create` +
            `?startedAt=${encodeURIComponent(gameById.startedAt)}` +
            `&countPlayers=${gameById.countPlace}` +
            `&systemId=${gameById.gameSystem.id}` +
            `&private=true` +
            `&id=${id}`
        );
    };

    const handleConfirm = async (id) => {
        try {
            await putStatus(id, true);
            navigateToSchedule(id);
            toast.success(`id: ${id} подтверждено`);
        } catch (err) {
            toast.error(err?.response?.data?.message || `id: ${id} не подтверждено`);
        }
    };

    const handleCancel = async (id) => {
        try {
            await putStatus(id, false);
            toast.success(`id: ${id} отклонено`);
        } catch (err) {
            toast.error(err?.response?.data?.message || `id: ${id} не отклонено`);
        }
        closePopup();
    };

    // === сортировка через мобильную модалку ===
    const handleChangeSort = (field, dir) => {
        setSortBy(field);
        setDirection(dir);
        setPage(0);
    };

    // поля сортировки под твои хедеры/бэкенд:
    const sortOptions = [
        { value: 'startedAt',       label: 'Дата' },
        { value: 'fio',             label: 'Имя и фамилия' },
        { value: 'phone',           label: 'Телефон' },
        { value: 'gameSystemName',  label: 'Система' },
    ];

    return (
        <div className={`container-fluid ${common.container}`}>
            {isMobile && (<h1 className={common.mobileHeading}>Заявки на закрытую игру</h1>)}

            <div className="mb-3">
                <div className="d-flex align-items-center">
                    <div className="col-md-5 col-10">
                        <input
                            type="text"
                            placeholder="Поиск"
                            className={`form-control w-100 ${common.searchInput}`}
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value);
                                setPage(0);
                            }}
                        />
                    </div>

                    {/* кнопка сортировки на мобилке */}
                    {isMobile && (
                        <div className="col-2 d-flex justify-content-end">
                            <button
                                type="button"
                                className={`${common.iconButton} ms-2`}
                                onClick={() => setShowModalFilters(true)}
                                aria-label="Открыть сортировку"
                            >
                                <GiSettingsKnobs size={20} />
                            </button>
                        </div>
                    )}
                </div>
            </div>

            {!isMobile ? (
                <table className={`table ${common.table}`}>
                    <thead className={common.tableHeader}>
                    <tr>
                        <th className={common.sortable} onClick={() => handleSort('startedAt')}>
                            Дата{renderSortArrow('startedAt')}
                        </th>
                        <th className={common.sortable} onClick={() => handleSort('fio')}>
                            Имя и фамилия{renderSortArrow('fio')}
                        </th>
                        <th className={common.sortable} onClick={() => handleSort('phone')}>
                            Телефон{renderSortArrow('phone')}
                        </th>
                        <th>Телеграм</th>
                        <th className={common.sortable} onClick={() => handleSort('gameSystemName')}>
                            Система{renderSortArrow('gameSystemName')}
                        </th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    {games.map((game, index) => {
                        const date = new Date(game.startedAt);
                        return (
                            <tr key={game.id} className={index % 2 === 1 ? common.altRow : ''}>
                                <td>{format(date, "dd.MM.yy 'в' HH:mm", { locale: ru })}</td>
                                <td>{game.fio || 'Не заполнено'}</td>
                                <td>{game.phone || 'Не заполнено'}</td>
                                <td>
                                    {game.telegram ? (
                                        <a
                                            href={`https://t.me/${extractTelegramUsername(game.telegram)}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {game.telegram}
                                        </a>
                                    ) : '—'}
                                </td>
                                <td>{game.gameSystemName || '—'}</td>
                                <td>
                                    <button
                                        className="btn-word black"
                                        onClick={() => {
                                            handleMore(game.id);
                                            setOpen(true);
                                        }}
                                    >
                                        Подробнее
                                    </button>
                                </td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            ) : (
                <div className={mob.mobileBlocksWrapper}>
                    {games.map((game,index) => (
                        <div key={index} className={mob.mobileBlock}>
                            <div className={mob.mobileBlockRow}>
                                <div className={mob.leftBLock}>
                                    <span className={`opacity-50`}>Клиент</span><br/>
                                    <span>{game.fio || '—'}</span>
                                </div>
                                <div className={mob.rightBLock}>
                  <span>
                    {game.telegram ? (
                        <a
                            href={`https://t.me/${extractTelegramUsername(game.telegram)}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {game.telegram}
                        </a>
                    ) : '—'}
                  </span>
                                    {game.phone}
                                </div>
                            </div>

                            <div className={mob.mobileBlockRow}>
                                <div className={mob.leftBLock}>
                  <span className={mob.mobileTitle}>
                    {format(new Date(game.startedAt), "dd.MM.yy 'в' HH:mm", { locale: ru })}
                  </span>
                                    <p>{game.gameSystemName || '—'}</p>
                                </div>
                                <div className={`${mob.rightBLock} ${mob.mobileBlockFooter}`}>
                                    <button
                                        className="btn-word"
                                        onClick={() => {
                                            handleMore(game.id);
                                            setOpen(true);
                                        }}
                                    >
                                        Подробнее
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            <Pagination page={page} totalPages={totalPages} onPageChange={handlePageChange} />

            {open && (
                <Popup isOpen={open} onClose={closePopup}>
                    <h3 className={"text-center mb-4"}>Заявка на закрытую игру</h3>
                    <div className={"row g-0"}>
                        <div className={ styles.popupBlock + " col-md"}>
                            {gameById?.siteUser?.fio || "-"}
                        </div>
                        <div className={ styles.popupBlock + " col-md"}>
                            {gameById?.gameSystem?.name || "-"}
                        </div>
                    </div>
                    <div className={"row g-0"}>
                        <div className={ styles.popupBlock + " col-md"}>
                            {gameById?.siteUser?.phone || "-"}
                        </div>
                        <div className={ styles.popupBlock + " col-md"}>
                            {gameById?.startedAt ? format(new Date(gameById.startedAt), "dd.MM.yy 'в' HH:mm", { locale: ru }) : '—'}
                            {gameById?.slotMode ? <span> выходной (выбран слот)</span> : <span> будний (выбрано время)</span> }
                        </div>
                    </div>
                    <div className={"row g-0"}>
                        <div className={ styles.popupBlock + " col-md"}>{gameById?.telegram}</div>
                        <div className={ styles.popupBlock + " col-md"}>
                            {gameById?.countPlace} {declOfNum(gameById?.countPlace, ['игрок', 'игрока', 'игроков'])}
                        </div>
                    </div>
                    <div className={`d-flex`}>
                        <div className={`${styles.popupBlock} ${styles.popupComment}  w-100`}>
                            {gameById?.description || "Нет комментария"}
                        </div>
                    </div>
                    {
                        gameById?.status === null ? (
                            (role !== "ADMIN" && role !== "MASTER") && (
                                <div className={"row g-0 gap-2"}>
                                    <div className="col-md">
                                        <button
                                            className={`${styles.btn} service-btn w-100`}
                                            onClick={() => handleConfirm(gameById?.id)}
                                        >
                                            Подтвердить
                                        </button>
                                    </div>
                                    <div className="col-md">
                                        <button
                                            className={`${styles.btnCancel} ${styles.btn} service-btn w-100`}
                                            onClick={() => handleCancel(gameById?.id)}
                                        >
                                            Отклонить
                                        </button>
                                    </div>
                                </div>
                            )
                        ) : gameById?.status === true ? (
                            <div className={"d-flex justify-content-center align-items-center flex-column"}>
                                <p className="body text-success text-center mt-3">Игра подтверждена</p>
                                {
                                    gameById?.scheduleId === null && (role !== "ADMIN" && role !== "MASTER") ? (
                                        <button
                                            className={"btn-word black mt-2"}
                                            onClick={() => {
                                                navigateToSchedule(gameById?.id)
                                            }}
                                        >
                                            Перейти к созданию карточки заявки
                                        </button>
                                    ) :  role !== "MASTER" && (
                                        <button
                                            className={"btn-word black mt-2"}
                                            onClick={() => {
                                                navigate(`/admin/schedule/edit/${gameById?.scheduleId}`)
                                            }}
                                        >
                                            Перейти на карточку заявки
                                        </button>
                                    )
                                }
                            </div>
                        ) : (
                            <>
                                <p className="body text-danger text-center mt-3">Игра отклонена</p>
                            </>
                        )
                    }
                </Popup>
            )}

            {/* модалка сортировки на мобилке */}
            <FilterModal
                isOpen={showModalFilters}
                onClose={() => setShowModalFilters(false)}
                sortOptions={sortOptions}
                sortBy={sortBy}
                direction={direction}
                onChangeSort={handleChangeSort}
            />
        </div>
    );
}

const declOfNum = (number, titles) => {
    const cases = [2, 0, 1, 1, 1, 2];
    return titles[
        (number % 100 > 4 && number % 100 < 20)
            ? 2
            : cases[(number % 10 < 5) ? number % 10 : 5]
        ];
};
